import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss'],
})
export class CustomAlertComponent implements OnInit {
  @Input() title : string = 'title not defined'
  @Input() type : string
  @Input() description : string = 'description not defined'
  @Input() body : Object = []

  private showDetails = false
  closed = false

  constructor() { }

  ngOnInit() {
  }

}
